import axiosInstance from "./AxiosInstance";


// Fetch paginated audit sessions
export const getAuditSessions = (params) => {
  return axiosInstance.get('/api/audit/audit-sessions-list', { params });
};

// Export audit sessions to Excel
export const exportAuditSessions = (params) => {
  return axiosInstance.get('/api/audit/audit-sessions-list', {
    params: { ...params, export: true },
    responseType: "blob",
  });
};

export const createAuditSession = (data) => {
  return axiosInstance.post("api/audit/audit-session-assign", data);
};
